export default "/images/vendor/flag-icons/flags/1x1/mr.svg?d7db7269c3c9a5fb4fcdeb5d8bb0ec93";